export default { 
  apiKey: "AIzaSyBsOHP2D8lp784RnN2iR7GYKCuHpA2XKKA", 
  authDomain: "ligur-io.firebaseapp.com", 
  databaseURL: "https://ligur-io.firebaseio.com", 
  projectId: "ligur-io", 
  storageBucket: "ligur-io.appspot.com", 
  messagingSenderId: "1091992732269", 
  appId: "1:1091992732269:web:3545ce2ed6bb3363caf564", 
  measurementId: "G-PXZEMGRRCM"
}